import React, { Component } from "react";
import { navigate, navigateWithInParent, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { resetTenantContext } from "@eres/ejari-core/contexts/TenantContext";
import Strings from "@my-dld/assets/strings";
import { DashboardSectionTitle } from "./Summary";
import { ActionProps } from "./QuickActions";
import { LocaleUtil } from "@eres/core";
import ServiceDescriptions from "@my-dld/assets/strings/svc_description";
import { getAppServices } from "@10x/coreapp";
import _ from "lodash";
import { resetIfEmpty, setEnvUser } from "@10x/rentalvaluation/RVUtils";
import { showRVPage } from "@10x/rentalvaluation/NavigationUtils";
import { isLoggedIn } from "@10x/sso";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { EjariProfile } from "@10x/sso/EjariProfile";
import { isEmailVerified } from "@my-dld/utils/User";
import { showUnverifiedEmailError } from "@my-dld/utils/UIUtils";
import Icons from "@my-dld/assets/icons";
import { AppIcon, IconName } from "@my-dld/components/AppIcon";

class PropertyServices extends Component {
	render() {
		let pps = _.sortBy( getAppServices().appService.getServices(), "order" );
		return <>
			{/*<div className="row">*/}
			{/*	<DashboardSectionTitle title={ Strings.property_services }/>*/}
			{/*</div>*/}
            <div className="row my-dld-action head-card g-3">
				<PropertyService
					allowUnverifiedEmailUsers={ false }
					label={ Strings.register_certificate }
                    icon={ "icon-mydld-ejari-contract" }
					cardDescription={ LocaleUtil.getLocalValue( ServiceDescriptions.register_certificate ) }
					onAction={ this.startTenantContract }/>
				<PropertyService
					allowUnverifiedEmailUsers={ true }
					label={ Strings.my_tenancy_requests }
                    icon={ "icon-mydld-request-sent" }
					cardDescription={ LocaleUtil.getLocalValue( ServiceDescriptions.my_certificate_request ) }
					link={ "/mydld/my_tenancy_requests" }/>
				<PropertyService
					allowUnverifiedEmailUsers={ true }
					label={ Strings.requests_from_tenant }
					icon={ "icon-mydld-request-received" }
					cardDescription={ LocaleUtil.getLocalValue( ServiceDescriptions.certificate_request_from_tenant ) }
					link={ "/mydld/requests_from_tenant" }/>
				<PropertyService
					allowUnverifiedEmailUsers={ false }
					label={ Strings.mollak_service_charges }
                    icon={ "icon-mydld-mollak-sc" }
					cardDescription={ LocaleUtil.getLocalValue( ServiceDescriptions.mollak_service_charges ) }
					link={ "/mydld/mollak_service_charges" }/>
				<PropertyService
					label={ Strings.view_mgm_contract_request }
                    icon={ "icon-mydld-mcrequest" }
					allowUnverifiedEmailUsers={ false }
					cardDescription={ LocaleUtil.getLocalValue( ServiceDescriptions.mgm_contracts ) }
					link={ "/mydld/management_contract_requests" }/>
				{ pps.map( svc => {
					let desc = svc.description;
					if ( !desc && svc.descriptionProvider ) {
						desc = LocaleUtil.getLocalValue( svc.descriptionProvider[ svc.id ] );
					}
					if ( !desc ) {
						desc = getAppServices().assetService.Strings( "svc_description" )[ svc.id ];
					}
					if ( !desc ) {
						const serviceDescription = ( ServiceDescriptions as any )[ svc.id ];
						desc = serviceDescription ? LocaleUtil.getLocalValue( serviceDescription as any ) : "";
					}
					return <PropertyService
						key={ svc.id }
						allowUnverifiedEmailUsers={ svc.allowUnverifiedEmailUsers }
						label={ LocaleUtil.getLocalValue( svc.label ) }
						icon={ svc.icon || "" }
						cardDescription={ desc }
						onAction={ () => {
							if ( svc.id === "rental_valuation" ) {
								this.startRV();
							} else {
								svc.action( svc );
							}
						} }/>;
				} ) }
			</div>
		</>;
	}

	private startTenantContract = () => {
		resetTenantContext();
		navigateWithInParent( "mydld", "tenant" );
	};

	private startRV = () => {
		// resetRVData();
		resetIfEmpty();
		setEnvUser();
		if ( isLoggedIn() ) {
			const tp = TabuProfile.getProfile();
			const ep = EjariProfile.getProfile();
			if ( tp || ep ) {
				showRVPage();
			} else {
				replaceNavigate( "/mydld" );
			}
		} else {
			replaceNavigate( "/mydld" );
		}
	};
}

export function PropertyService<T extends string | IconName>( props: ActionProps<T> ) {
	const defClassName = "col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12";
	const { icon, label, cardDescription, className, allowUnverifiedEmailUsers } = props;
	const clickAction = () => {
		const oAction = () => {
			const { onAction, link } = props;
			if ( onAction ) {
				onAction();
			} else if ( link )
				navigate( link );
		};
		if ( allowUnverifiedEmailUsers ) {
			oAction();
		} else {
			if ( isEmailVerified() ) {
				oAction();
			} else {
				showUnverifiedEmailError();
			}
		}
	};

	const i = icon in Icons ? <AppIcon name={ icon as keyof typeof Icons }/> : <i className={ icon }/>;
	return <div className={className ? className : defClassName}>
		<div className="card" onClick={clickAction}>
			<span className="service-icon"><i className={icon}></i></span>
			<span className="service-name">{ label }</span>
			<span className="service-description">{ cardDescription }</span>
		</div>
	</div>;
}

export default PropertyServices;
